import { BrowserRouter, matchPath, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/layouts/navbar';
import Footer from './components/layouts/footer';
import Home from './pages/home';
import Products from './pages/products';
import LoginPage from './components/layouts/login';
import SignupPage from './components/layouts/signup';
import { ToastContainer } from 'react-toastify';
import { CartWishlistProvider, useCartWishlist } from './context/cartwishlistcontext';
import { AuthProvider } from './context/authContext';
import CartPage from './pages/cart';
import WishlistPage from './pages/wishlist';
import ScrollToTop from './components/comman/scrollToTop';
import ProductDetailPage from './pages/productDetail';
import Service from './pages/service';
import ServiceDetailPage from './pages/serviceDetail';
import Checkout from './pages/checkout';
import BookServicePage from './pages/bookService';
import Profile from './pages/profile';
import ManageAddress from './pages/manageAddress';
import ReturnPolicySection from './pages/returnPolicy';
import PrivatePolicySection from './pages/privatePolicy';
import FAQPage from './pages/FAQPage';
import OrderPage from './pages/orderPage';
import OrderDetail from './pages/orderDetail';
import TrackOrder from './components/feature/Order/trackOrder';
import InvoicePage from './pages/InvoicePage';
import Contact from './pages/contact';
import BookedService from './pages/bookedServices';
import ViewUpcomingService from './components/feature/bookedServices/viewupcomingservices';
import ServiceInvoicePage from './pages/serviceInvoicePage';
import WishlistModal from './modal/wishlistMove';
import CartMovedModal from './modal/cartMove';
import ViewEstimation from './components/feature/bookedServices/viewEstimation';
import ViewInvoice from './components/feature/bookedServices/viewInvoice';
import ServicePaymentPage from './components/feature/bookedServices/ServicePaymentPage';
import ForgetPassword from './pages/forgetPassword';
import ResetPassword from './pages/resetPassword';
import ReturnOrderDetail from './components/feature/Order/returnOrderDetail';

function AppLayout() {
const location = useLocation();
const hideLayoutPaths = ["/signup", "/login",];

const hideLayout = hideLayoutPaths.some((path) =>
    path.includes(":")
      ? matchPath({ path, end: false }, location.pathname)
      : location.pathname === path
  );


  return (
    <>
      {!hideLayout && <Navbar />}
      <Routes>
          <Route path="/" element={<Home />} />     
          <Route path="/productpage" element={<Products/>}/> 
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />  
          <Route path="/cartpage" element={<CartPage />} /> 
          <Route path="/wishlistpage" element={<WishlistPage />} /> 
          <Route path="/productdetail/:id" element={<ProductDetailPage />} />   
          <Route path="/service" element={<Service />} /> 
          <Route path="/servicedetail/:id" element={<ServiceDetailPage />} />   
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/bookservice" element={<BookServicePage />} /> 
          <Route path="/profilepage" element={<Profile />} />
          <Route path="/manageaddress" element={<ManageAddress />} />   
          <Route path="/returnpolicy" element={<ReturnPolicySection />} />
          <Route path="/privatepolicy" element={<PrivatePolicySection />} />
          <Route path="/faqpage" element={<FAQPage />} />
          <Route path="/orderpage" element={<OrderPage />} />   
          <Route path="/orderdetail/:id" element={<OrderDetail />} /> 
          <Route path="/ordertrack/:id" element={<TrackOrder />} />
          <Route path="/invoicepage/:id" element={<InvoicePage />} />
          <Route path="/serviceinvoicepage/:id" element={<ServiceInvoicePage />} />
          <Route path="/contactpage" element={<Contact />} /> 
          <Route path="/bookedservices" element={<BookedService />} />
          <Route path="/viewupcomingservices/:id" element={<ViewUpcomingService />} /> 
          <Route path="/viewestimation/:id" element={<ViewEstimation />}/>
          <Route path="/viewinvoice/:id" element={<ViewInvoice />}/>
          <Route path="/servcice-pay-payment/:id" element={<ServicePaymentPage />}/>
          <Route path="/forgetpassword" element={<ForgetPassword />}/>
          <Route path="/reset-password/:token" element={<ResetPassword />}/>
          <Route path="/return-order-detail/:id" element={<ReturnOrderDetail/>}/>
      </Routes>
      {!hideLayout && <Footer />}
     
    </>
  );
}
function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <AuthProvider>
      <CartWishlistProvider>
        <ScrollToTop />        
        <AppLayout/>
        <ToastContainer position="top-right" autoClose={2000} />
         <WishlistModalWrapper />
         <CartModalWrapper/>
        </CartWishlistProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
function WishlistModalWrapper() {
  const { isWishlistModalOpen, setIsWishlistModalOpen } = useCartWishlist();

  if (!isWishlistModalOpen) return null;

  return <WishlistModal onClose={() => setIsWishlistModalOpen(false)} />;
}
function CartModalWrapper() {
  const {  isCartModalOpen,setIsCartModalOpen } = useCartWishlist();

  if (!isCartModalOpen) return null;

  return <CartMovedModal onClose={() => setIsCartModalOpen(false)} />;
}
export default App;

